import Vue from 'vue'

/**
 * @author jorge nuñez lópez <>
 *
 * Release Output requests
 * @param outputsRequest Output requests object
 * @return {object}
 */

export default (outputsRequest) => {
  return Vue.$http.post(`/iwarehouse/quantification/approve-output/`, outputsRequest)
}


// WEBPACK FOOTER //
// ./src/services/purchase/warehouse/releaseMaterial.js